<template>
<span>
    <tolid-details></tolid-details>
    <page-footer></page-footer>
</span>
</template>
<script>
import TolidDetails from '@/components/moduls/TolidDetails';
import PageFooter from '@/components/PageFooter';
export default {
    name :'tolid',
    components:{
        TolidDetails,
        PageFooter
    }

    
};
</script>


